var _circle, _circle2, _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnexpectedError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 250,
    viewBox: "0 0 251 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8448_155310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 251,
    height: 250
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 125,
    fill: "#F1F1F2"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8448_155310)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 125,
    fill: "#8CD1FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8448_155310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 30,
    width: 107,
    height: 157
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.086 30.1328C133.143 30.1328 137.567 33.5322 138.87 38.4178L178.327 186.383H72.673L112.13 38.4178C113.433 33.5322 117.857 30.1328 122.914 30.1328H128.086Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8448_155310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.086 30.1328C133.143 30.1328 137.567 33.5322 138.87 38.4178L178.327 186.383H72.673L112.13 38.4178C113.433 33.5322 117.857 30.1328 122.914 30.1328H128.086Z",
    fill: "#FA6400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.304 30.1328H125.5L147.821 189.731H181.304V30.1328Z",
    fill: "#E15300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.723 132.812H76.3928V159.598H175.723V132.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.723 132.812H125.5V159.598H175.723V132.812Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.723 79.2383H76.3928V106.024H175.723V79.2383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.723 79.2383H125.5V106.024H175.723V79.2383Z",
    fill: "#F8F8F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8448_155310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 186,
    width: 157,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6071 186.383H201.393C202.626 186.383 203.625 187.382 203.625 188.615V191.963C203.625 195.045 201.127 197.544 198.045 197.544H52.9554C49.8734 197.544 47.375 195.045 47.375 191.963V188.615C47.375 187.382 48.3744 186.383 49.6071 186.383Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8448_155310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6071 186.383H201.393C202.626 186.383 203.625 187.382 203.625 188.615V191.963C203.625 195.045 201.127 197.544 198.045 197.544H52.9554C49.8734 197.544 47.375 195.045 47.375 191.963V188.615C47.375 187.382 48.3744 186.383 49.6071 186.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 186.383H47.375V197.544H125.5V186.383Z",
    fill: "#46474A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnexpectedError);
export default __webpack_public_path__ + "static/media/unexpected_error.1a33fbc945cd90442549cd845fa04126.svg";
export { ForwardRef as ReactComponent };